import Page from './index';

export default { path: '/home/tenant/contractCoin', component: Page };
